import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Registration = lazy(() => import('../pages/registration/page'));
const Regulations = lazy(() => import('../pages/regulations/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/registration',
    element: <Registration />,
  },
  {
    path: '/regulations',
    element: <Regulations />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;